<template>
    <div id="listContact">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div :class="'page-header-top-container'+titleMargin">
                    <div class="page-name color-71aa3f">{{contactPageData.pageTitle}}</div>
                    <template v-for="(permission, index) in permissions">
                        <button title="Add" v-if="permission.name == 'can_add_new_contact'" type="button" class="btn general-button btn-primary icon-btn" id="submit" name="submit"
                                v-on:click.prevent="editRentalRage">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>
                    </template>
                    <!--<v-select class="col-sm-12 col-md-2 pull-right" 
                              v-model="contact_data_type" 
                              name="customer_id"
                              label="text" 
                              :searchable="false" 
                              :filterable="false" 
                              :clearable=false
                              :options="contact_data_type_arr"
                              placeholder="Select Type">
                    </v-select>-->
                    <div class="btn-group pull-right">
                        <button type="button" class="btn_all_cont btn general-button btn-primary" v-on:click="allClickContacts()">All </button>
                        <button type="button" class="btn_my_cont btn general-button btn-secondary" v-on:click="myClickContacts()">My Self</button>
                    </div>
                </div>
                <div class="admin-page-content">
                    <div class="app-filter-good-table-container">
                        <vue-good-table class="contactTable"
                                        ref="listContactTable"
                                        mode="remote"
                                        title="Contacts"
                                        @on-page-change="onPageChange"
                                        @on-selected-rows-change="selectionChanged"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        @on-sort-change="onSortChange"
                                        :totalRows="totalContactRecords"
                                        :columns="columnsContacts"
                                        :rows="rows"
                                        :pagination-options="{
                                        enabled: true,
                                        mode: 'pages',
                                        pageLabel: 'Page',
                                        position: 'bottom',
                                        perPage: serverParamsContact.perPage,
                                        setCurrentPage: serverParamsContact.setCurrentPage,
                                        perPageDropdown: serverParamsContact.perPageDropdown,
                                        dropdownAllowAll: false,
                                        }"

                                        :search-options="{
                                        enabled: false,
                                        }">
                            <template slot="pagination-bottom" slot-scope="props">
                                <div class="vgt-wrap__footer crm" v-if="totalContactRecords > 0">
                                    <div  class="row">
                                        <div class="col-sm-12 col-md-2 PerPage">
                                            <v-select title="Select Per Page"
                                                      v-model="serverParamsContact.perPage"
                                                      @input="changedValueCustomPerPage()"
                                                      name="customPerPage"
                                                      id="customPerPage"
                                                      label="text"
                                                      :clearable="false"
                                                      :searchable="false"
                                                      :filterable="false"
                                                      :options="serverParamsContact.perPageDropdown"
                                                      placeholder="Select Per Page">
                                            </v-select>
                                        </div>
                                        <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                            <p class="pageRowCount">{{paginationDisplayRowsContact}} of {{totalContactRecords}}</p>
                                        </div>
                                        <div class="col-sm-12 col-md-6 Pagination">
                                            <ul class="pagination">
                                                <li class="page-item FirstPage" title="First Page">
                                                    <template v-if="Number(serverParamsContact.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClick(1)" class="page-link" href="javascript:void(0)">1</a>
                                                    </template>
                                                </li>
                                                <li class="page-item PreviousPage" title="Previous Page">
                                                    <template v-if="Number(serverParamsContact.page) == 1">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClick(Number(serverParamsContact.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                    </template>
                                                </li>
                                                <!--New Implementation-->
                                                <template v-if="pageNumberList() < displayPageContact">
                                                    <template v-for="(n, index) in pageNumberList()">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsContact.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <!--End New Implementation-->
                                                    <template v-if="Number(serverParamsContact.page) <= pageCompareContact">
                                                        <template v-for="(n, index) in displayPageContact">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsContact.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                    <template v-else-if="Number(serverParamsContact.page) >= (pageNumberList() - (pageCompareContact-1))">
                                                        <template v-for="(n, index) in pageNumberList()">
                                                            <template v-if="n > (pageNumberList() - displayPageContact)">
                                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsContact.page)">
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                    <a class="page-link" href="javascript:void(0)">
                                                                        {{n}}
                                                                    </a>
                                                                </li>
                                                            </template>
                                                        </template>
                                                    </template>
                                                    <template v-else>
                                                        <template v-for="(n, index) in pageNumberList()" v-if="(n >= (Number(serverParamsContact.page) - (pageCompareContact -1))) && (n <= (Number(serverParamsContact.page) + (pageCompareContact -1)))">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParamsContact.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClick(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <li class="page-item NextPage" title="Next Page">
                                                    <template v-if="Number(serverParamsContact.page) == pageNumberList()">
                                                        <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                    <template v-else>
                                                        <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClick(Number(serverParamsContact.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                    </template>
                                                </li>
                                                <li class="page-item LastPage" title="Last Page">
                                                    <template v-if="Number(serverParamsContact.page) == pageNumberList()">
                                                        <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberList()}}</a>
                                                    </template>
                                                    <template v-else>
                                                        <a v-on:click="onPerticularPageClick(pageNumberList())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberList()}}</a>
                                                    </template>
                                                </li>
                                            </ul>
                                        </div>                                
                                        <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <p class="pageJumpLabel">Page : </p>
                                        </div>
                                        <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                            <input @keyup.enter="jumpToPageInContact" v-model="jumpToPageContact" type="text" class="form-control form-control-sm" name="jumpToPageContact" id="jumpToPageContact" placeholder="Page">
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                <div :key="key">
                                    <div v-if="props.column.field == 'action'" class="actionButton">
                                        <!--class="btn btn-xs general-button btn-primary"-->
                                        <template v-if="permission.name == 'can_add_new_contact'" v-for="(permission, index) in permissions">
                                            <router-link title='Edit contact' v-if="props.row.data_source != 'excede'" class="btn edit-btn-vvg waves-effect" v-bind:to="{name: 'EditContact',params:{id:props.row.id,from:contactPageData.cus_id}}"><i class="fa fa-pencil-square-o"></i></router-link>
                                        </template>
                                        <template v-if="permission.name == 'can_see_contact_view'" v-for="(permission, index) in permissions">
                                            <router-link title='View contact details' class="btn edit-btn-vvg waves-effect" v-bind:to="{name: 'ContactView',params:{id:props.row.id,from:contactPageData.cus_id}}"><i class="fa fa-eye"></i></router-link>
                                        </template>
                                        <template v-if="props.row.data_source != 'excede'">
                                            <template v-if="permission.name == 'can_change_contact_settings'" v-for="(permission, index) in permissions">
                                                <span style="margin: 0px !important" v-if="props.row.status == '1'" title='Inactive contact' class="activeContact btn edit-btn-vvg waves-effect" v-on:click.prevent="changeContactStatus(props.row.id)"><i class="fa fa-times"></i></span>
                                                <span style="margin: 0px !important" v-if="props.row.status == '0'" title='Active contact' class="inactiveContact btn edit-btn-vvg waves-effect" v-on:click.prevent="changeContactStatus(props.row.id)"><i class="fa fa-check"></i></span>
                                            </template>
                                            <template v-if="permission.name == 'can_add_new_contact'" v-for="(permission, index) in permissions">
                                                <span style="margin: 0px !important" title='Delete contact' class="btn edit-btn-vvg waves-effect" v-on:click.prevent="deleteContact(props.row.id)"><i class="fa fa-trash"></i></span>
                                            </template>
                                        </template>
                                    </div>
                                    <div v-else>
                                        {{props.formattedRow[props.column.field]}}
                                    </div>
                                </div>
                            </template>
                            <!--<div slot="selected-row-actions" slot-scope="computed">
                            {{computed.selectedRows}}
                            <button v-on:click="sendMail" class="btn general-button btn-success waves-effect">Mail</button>
                            </div>-->
                        </vue-good-table>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>


    // import { headers } from "../config";
    import {configs} from '../../config';
    import SessioMixin from '../../mixins/sessionmixin';
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import FrontMenu from '@/components/partials/FrontMenu';
    import EventBus from '../event-bus';
    import {listContactTable} from '../../config';
    import swal from 'sweetalert2/dist/sweetalert2.js';
    const Swal = require('sweetalert2');

    Vue.use(VueGoodTable);

    export default {
        name: "listContact",
        mixins: [SessioMixin],
        props: {
            contactPageData: '',
        },
        data: () => ({
                contact_data_type: {value: 'all', text: "All"},
                contact_data_type_arr: [
                    {value: 'all', text: "All"},
                    {value: 'my', text: "My Self"}
                ],
                titleMargin: '',
                displayPageContact: 7,
                pageCompareContact: 0,
                paginationDisplayRowsContact: '',
                jumpToPageContact: 0,

                permissions: [],
                cantAccessPage: true,
                message: 'all',
                isLoggedIn: false,
                firstLoad: 0,
                columnsContacts: [
                    {
                        label: 'Collector',
                        field: 'collector',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Collector", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'CusId',
                        field: 'cusid',
                        filterable: true,
                        width: '100px',
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "CusId", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Customer Name',
                        field: 'customername',
                        filterable: true,
                        width: '160px',
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Contact Name',
                        field: 'first_name',
                        filterable: true,
                        width: '160px',
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Contact Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Email',
                        field: 'email',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Email", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Phone',
                        field: 'phone',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Phone", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Fax',
                        field: 'fax',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Fax", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'City',
                        field: 'city',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "City", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Postal Code',
                        field: 'postal_code',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Postal Code", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Created At',
                        field: 'created_at',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Created At", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                        width: '150px',
                    },
                ],
                rows: [],
                totalContactRecords: 0,
                serverParamsContact: {
                    columnFilters: {

                    },
                    sort: {
                        field: 'cusid',
                        type: 'desc',
                    },
                    page: 1,
                    perPage: 25,
                    setCurrentPage: 1,
                    perPageDropdown: [],
                },
            }),
        watch: {
            contact_data_type: function (contact_data_type) {
                var self = this;
                self.message = self.contact_data_type.value;
                self.loadContacts();
            },
            'serverParamsContact.perPage': {
                handler() {
                    this.onPerPageChange();
                },
            }
        },
        mounted: function () {
            var app = this;
            app.showLoader();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
            app.jumpToPageContact = app.serverParamsContact.page;
            app.pageCompareContact = Math.ceil(app.displayPageContact / 2);
            $("#jumpToPageContact").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    app.jumpToInputPage(app.jumpToPageContact)
                }
            });
            if (app.contactPageData.is_part == 1) {
                app.titleMargin = " pt-0";
            }
            if (app.contactPageData.cus_id > 0) {
                app.loadFilters('menucontactscustomer', app.columnsContacts, app.serverParamsContact, 'contactTable');
            } else {
                app.loadFilters('menucontacts', app.columnsContacts, app.serverParamsContact, 'contactTable');
            }
            app.serverParamsContact.perPage = app.contactPageData.perPage;
            for (var i = app.contactPageData.perPage; i < 100; ) {
                app.serverParamsContact.perPageDropdown.push(i);
                if (app.contactPageData.perPage < 5) {
                    i = i * 5;
                } else {
                    i = i * 2;
                }
            }
            app.serverParamsContact.perPageDropdown.push(100);
            app.serverParamsContact.perPageDropdown.push(200);
            app.serverParamsContact.perPageDropdown.push(500);
            app.loadContacts();
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
                app.getPermissions();
            }
            if (app.contactPageData.cus_id > 0) {
                app.columnsContacts['1'].filterOptions.enabled = false;
                app.columnsContacts['2'].filterOptions.enabled = false;
            }
        },
        methods: {
            /*customPageChange(customCurrentPage) {
             },
             customPerPageChange() {
             },*/
            jumpToPageInContact: function (e) {
                let self = this;
                self.jumpToInputPage(self.jumpToPageContact);
            },
            changedValue: function (value) {
                /*console.log(value);*/
            },
            jumpToInputPage: function (pageNumber) {
                var self = this;
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberList()) {
                    pageNumber = self.pageNumberList();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageContact).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClick(pageNumber);
            },
            onPerticularPageClick: function (pageNumber) {
                var self = this;
                self.serverParamsContact.page = pageNumber;
                self.jumpToPageContact = pageNumber;
                /* Single Backend Call on page load start */
                if(self.firstLoad != 1 && self.jumpToPageContact != 1) {
                    self.loadContacts();
                } else if(self.firstLoad == 1 && self.jumpToPageContact >=1) {
                    self.loadContacts();
                }
                /* Single Backend Call on page load end */
            },
            pageNumberList: function () {
                var self = this;
                var totalRecord = self.totalContactRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParamsContact.perPage;
                    count++;
                }
                return count;
            },
            changedValueCustomPerPage: function () {
                var self = this;
                /* Single Backend Call on page load start */
                if(self.firstLoad != 1) {
                    self.jumpToInputPage(self.serverParamsContact.page);
                    self.loadContacts();
                }
                /* Single Backend Call on page load end */
            },
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_see_contact_list') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            changeContactStatus: function (id) {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/contact/changestatus",
                    type: "POST",
                    data: {'id': id},
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.loadContacts();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            deleteContact: function (id) {
                var self = this;
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        $.ajax({
                            url: process.env.ROOT_API + "/contact/remove",
                            type: "POST",
                            data: {'contact_id': id},
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            dataType: 'json',
                            success: function (data) {
                                if (data.status == 'success') {
                                    Swal.fire(
                                        'Deleted!',
                                        'Contact deleted successfully',
                                        'success'
                                    );
                                    self.loadContacts();
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.cantAccessPage = false;
                                if (jqXHR.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (jqXHR.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem('user_obj');
                                        localStorage.removeItem('api_token');
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }
                                    self.error = jqXHR.responseJSON.message;
                                }
                            }
                        });
                    }
                });
            },
            editRentalRage() {
                var self = this;
                self.$router.push("/contacts/create/" + self.contactPageData.cus_id);
            },

            sendMail: function () {

                //console.log("selected rows", this.$refs['listContactTable'].selectedRows)
            },
            updateParams(newProps) {
                this.serverParamsContact = Object.assign({}, this.serverParamsContact, newProps);
            },
            //
            onPageChange(params) {
                this.updateParams({page: params.currentPage});

                this.loadContacts();
            },
            //
            onPerPageChange() {
                this.updateParams({perPage: this.serverParamsContact.perPage});
                this.totalContactRecords = this.totalContactRecords;
                this.loadContacts();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field: ('collector');
                    field: ('cusid');
                    field: ('customername');
                    field: ('first_name');
                    field:('email');
                    field:('phone');
                    field:('fax');
                    field:('city');
                    field:('postal_code');
                    field:('created_at');
                }
                ;
                this.serverParamsContact.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParamsContact));
                var filters = filtersPr.columnFilters;

                if (this.firstLoad == 1 || filters.cusid || filters.customername || filters.first_name || filters.email
                        || filters.phone || filters.fax || filters.city || filters.postal_code || filters.created_at || filters.collector) {
                    this.loadContacts();
                }

            },
            selectionChanged() {

                var self = this;
                // console.log( this.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params.sortType,
                        field: this.columnsContacts[params.columnIndex].field,
                        /*type: params[0].type,
                         field: params[0].field,*/
                    },
                });
                this.loadContacts();
            },
            //edit rental page
            viewDetails(params) {

                var self = this;
                self.$router.push("/viewContact/" + params.row.id);
            },
            allClickContacts: function () {
                var self = this;
                self.message = 'all';
                self.loadContacts();
            },
            myClickContacts: function () {
                var self = this;
                self.serverParamsContact.page = 1;
                self.jumpToPageContact = 1;
                self.message = 'my';
                self.loadContacts();
            },

            loadContacts: function () {
                var self = this;
                self.serverParamsContact.setCurrentPage = self.serverParamsContact.page;
                if (self.message == 'my') {
                    self.toggleButtons(self.message, 'btn_my_cont', 'btn_all_cont');
                } else {
                    self.toggleButtons(self.message, 'btn_all_cont', 'btn_my_cont');
                }
                if (self.contactPageData.cus_id > 0) {
                    var fields = {
                        page: self.serverParamsContact.page,
                        perPage: self.serverParamsContact.perPage,
                        filters: self.serverParamsContact.columnFilters,
                        messageData: self.message,
                        sort: self.serverParamsContact.sort,
                        custid: self.contactPageData.cus_id
                    };
                    self.storeFilters('menucontactscustomer', self.serverParamsContact, false);
                } else {
                    var fields = {
                        page: self.serverParamsContact.page,
                        perPage: self.serverParamsContact.perPage,
                        filters: self.serverParamsContact.columnFilters,
                        messageData: self.message,
                        sort: self.serverParamsContact.sort,
                    }
                    self.storeFilters('menucontacts', self.serverParamsContact, false);
                }

                this.firstLoad = 1
                // console.log(self.serverParamsContact.perPage);
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/contact/list",
                    type: "GET",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.code == '200') {
                            self.rows = data.content.row;
                            self.totalContactRecords = data.content.totalRecords;
                            self.showHidePagination("contactTable", self.totalContactRecords);
                            self.jumpToPageContact = self.serverParamsContact.page;
                            setTimeout(function () {
                                $('.actionButton').closest('tr').removeClass("bg-color-dddddd");
                                $('.inactiveContact').closest('tr').addClass("bg-color-dddddd");
                            }, 100);
                        }
                        self.paginationDisplayRowsContact = self.getRecords(self.serverParamsContact.page, self.serverParamsContact.perPage, self.totalContactRecords);
                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }


                            self.error = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }

                });
            },

            addContact() {
                var self = this;
                self.$router.push("/customerform/" + self.contactPageData.cus_id)
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }

        }
    };
</script>
<style>
    .vgt-checkbox-col input {
        opacity: 1 !important;
        position: static !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/contact/ListContactComponent.vue